import { BackBar, NavFrom } from "@/components/BackBar";

import { peekBuilderReturn } from "./builderReturn";

/**
 * "← Back to your booking draft", for the pages a host is sent to in the middle of building a
 * link: calendar settings, and the plans page they may pass through on the way.
 *
 * It reads the marker rather than router state because connecting a calendar leaves the app and
 * returns on a fresh page load, which router state does not survive. Nothing renders for a host
 * who came to these pages on their own.
 */
export function BuilderReturnCrumb() {
  const mark = peekBuilderReturn();
  if (!mark) return null;
  const from: NavFrom = {
    label: mark.offering === "rollingLink" ? "your rolling draft" : "your booking draft",
    to: "/booking-pages",
  };
  return <BackBar from={from} />;
}
